import { useReportingPageTable } from '@views/pages/Reporting/Reports/hooks/useReportingPageTable.ts';
import { Box, Typography } from '@mui/material';
import { ReportDataGrid } from '@views/pages/Reporting/Reports/components/ReportDataGrid.tsx';
import { t } from 'i18next';
import { ConfirmationModal } from '@components';
import { FC } from 'react';
import { InsertDriveFile } from '@mui/icons-material';

export interface ReportingPageTableProps {
  query:
    | 'all'
    | 'favorites_only'
    | 'recently_viewed'
    | 'created_by_me'
    | 'recently_deleted';
}

export const ReportingPageTable: FC<ReportingPageTableProps> = ({ query }) => {
  const {
    filters,
    entries,
    handleFilterChange,
    totalCount,
    loading,
    handleDeleteReport,
    deleteReportIsLoading,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    handleOpenDeleteModal,
    handleMakeReportFavorite,
    makeReportFavoriteIsPending,
    reportIdToFavorite,
    isInitialFilters,
  } = useReportingPageTable({ query });

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {entries.length === 0 && isInitialFilters && !loading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <InsertDriveFile
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('reporting.report.table.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {t('reporting.report.table.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <ReportDataGrid
          rows={entries}
          filters={filters}
          setFilters={handleFilterChange}
          totalCount={totalCount}
          loading={loading}
          handleOpenDeleteModal={handleOpenDeleteModal}
          handleMakeReportFavorite={handleMakeReportFavorite}
          makeReportFavoriteIsPending={makeReportFavoriteIsPending}
          reportIdToFavorite={reportIdToFavorite}
        />
      )}

      <ConfirmationModal
        title={t('reporting.report.deleteModal.title')}
        message={t('reporting.report.deleteModal.message')}
        onConfirm={handleDeleteReport}
        onClose={handleCloseDeleteModal}
        isOpen={isDeleteModalOpen}
        isLoading={deleteReportIsLoading}
        confirmText={t('general.delete')}
      />
    </Box>
  );
};
